/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangePasswordRequest,
  UpdateUserSettingsCommand
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiUsersMe = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Users/me`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiUsersMeQueryKey = () => {
    return [
    `/api/Users/me`
    ] as const;
    }

    
export const getGetApiUsersMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersMe>>> = ({ signal }) => getApiUsersMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiUsersMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersMe>>>
export type GetApiUsersMeQueryError = unknown


export function useGetApiUsersMe<TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersMe>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiUsersMe<TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersMe>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiUsersMe<TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiUsersMe<TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiUsersMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const putApiUsersMeSettings = (
    updateUserSettingsCommand: UpdateUserSettingsCommand,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/Users/me/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserSettingsCommand
    },
      options);
    }
  


export const getPutApiUsersMeSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUsersMeSettings>>, TError,{data: UpdateUserSettingsCommand}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiUsersMeSettings>>, TError,{data: UpdateUserSettingsCommand}, TContext> => {

const mutationKey = ['putApiUsersMeSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUsersMeSettings>>, {data: UpdateUserSettingsCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiUsersMeSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiUsersMeSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUsersMeSettings>>>
    export type PutApiUsersMeSettingsMutationBody = UpdateUserSettingsCommand
    export type PutApiUsersMeSettingsMutationError = unknown

    export const usePutApiUsersMeSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUsersMeSettings>>, TError,{data: UpdateUserSettingsCommand}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiUsersMeSettings>>,
        TError,
        {data: UpdateUserSettingsCommand},
        TContext
      > => {

      const mutationOptions = getPutApiUsersMeSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiUsersMeChangePassword = (
    changePasswordRequest: ChangePasswordRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Users/me/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordRequest, signal
    },
      options);
    }
  


export const getPostApiUsersMeChangePasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersMeChangePassword>>, TError,{data: ChangePasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersMeChangePassword>>, TError,{data: ChangePasswordRequest}, TContext> => {

const mutationKey = ['postApiUsersMeChangePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersMeChangePassword>>, {data: ChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsersMeChangePassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersMeChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersMeChangePassword>>>
    export type PostApiUsersMeChangePasswordMutationBody = ChangePasswordRequest
    export type PostApiUsersMeChangePasswordMutationError = unknown

    export const usePostApiUsersMeChangePassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersMeChangePassword>>, TError,{data: ChangePasswordRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersMeChangePassword>>,
        TError,
        {data: ChangePasswordRequest},
        TContext
      > => {

      const mutationOptions = getPostApiUsersMeChangePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    